import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Paragraph
 *
 * This component is in charge of displaying
 * a slide paragraph
 *
 * @return {jsx}
 */

const Paragraph = ({ className, children }) => <p className={className}>{children}</p>;

/**
 * Display Name
 */
Paragraph.displayName = 'Slide.Paragraph';

/**
 * PropTypes Validation
 */
const { node, string } = PropTypes;
Paragraph.propTypes = {
  className: string,
  children: node,
};

/**
 * Default Props
 */
Paragraph.defaultProps = {
  className: '',
  children: null,
};

export default styled(Paragraph)`
  font-size: ${({ theme: { fonts } }) => fonts.size.big};
  color: ${({ theme: { palette } }) => palette.darkBlue};
  line-height: ${({ theme: { fonts } }) => fonts.size.h4};
`;



// WEBPACK FOOTER //
// ./src/components/Slide/Paragraph/index.js